<template>
  <div>
    <span class="input-label">Button Display Mode</span>
    <el-select
      filterable
      @change="handleChange"
      :value="buttonDisplayMode"
      placeholder="Select"
      name="ButtonDisplayMode"
      class="input-select"
    >
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        <span class="select-label">{{ item.label }}</span>
        <span class="select-value">{{ item.value }}</span>
      </el-option>
    </el-select>
    <el-tooltip effect="dark" :content="detail" placement="top-end">
      <i class="el-icon-question detail-icon" />
    </el-tooltip>
  </div>
</template>

<script>
import _ from "lodash";
import { ButtonDisplayMode } from "@/store/types";

export default {
  name: "ButtonDisplayMode",
  props: ["node"],
  data() {
    return {
      detail: "Choose how the button is displayed in webchat.",
      options: [
        {
          label: "Default",
          value: ButtonDisplayMode.DEFAULT,
        },
        {
          label: "Always show",
          value: ButtonDisplayMode.ALWAYS,
        },
        {
          label: "Disable if not last message",
          value: ButtonDisplayMode.DISABLE_IF_NOT_LAST,
        },
      ],
    };
  },
  computed: {
    buttonDisplayMode() {
      return _.get(this.node, "options.buttonDisplayMode", ButtonDisplayMode.DEFAULT);
    },
  },
  methods: {
    handleChange(value) {
      const newNode = _.cloneDeep(this.node);
      if (!newNode.options) {
        newNode.options = {
          buttonDisplayMode: value,
        };
      } else {
        newNode.options.buttonDisplayMode = value;
      }
      this.$emit("updateNode", newNode);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/colors.scss";
.select-value {
  float: right;
  color: $color-grey;
  font-size: 13px;
  margin-left: 1.5em;
}

.select-label {
  float: left;
}

.input-select {
  margin-bottom: 1em;
  width: 160px;
}

.input-label {
  margin-left: 0px;
  margin-right: 1.5em;
  color: $color-grey;
  font-size: 14px;
}

.detail-icon {
  margin-left: 0.5em;
  color: $color-grey;
}
</style>
